import React from 'react'
import Header from '../header'
import InformationFooter from '../footer/information'
import TitleBar from '../title-bar'
import Footer from '../footer'
import Layout from './default'
import SticySpacer from '../botones/sticky-spacer'

export default ({ children, footer, multicanalidad, pais}) => {
  return (
    <Layout>
      <Header {...pais} />
      {children}
      <TitleBar title="Información" subtitle="De contacto" />
      <InformationFooter footer={footer} {...pais} />
      <Footer />
      {multicanalidad && <SticySpacer />}
    </Layout>
  );
};
